// eslint-disable-next-line no-restricted-syntax
import { type ListIterateeCustom, type ListIteratorTypeGuard } from "lodash";
import filter from "lodash/filter";
import find from "lodash/find";
import findKey from "lodash/findKey";
import keys from "lodash/keys";
import omit from "lodash/omit";
import some from "lodash/some";
import { FormSchemaField, Sections } from "PFApp/types/activity_form/activity_form_schema";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { useActivityFormStore } from "../activity_form_store";

export const useSectionsUtils = () => {
  const {
    formState: { errors }
  } = useFormContext();
  const formSchema = useActivityFormStore((state) => state.formSchema);

  const getFieldSection = (fieldName: string) =>
    findKey(formSchema, (sectionFields) => some(sectionFields, { name: fieldName })) as Sections | undefined;

  const isFieldVisible = (fieldName: string) => !!getFieldSection(fieldName);

  const getSectionFieldsBy = (
    section: Sections,
    condition:
      | ListIteratorTypeGuard<FormSchemaField, FormSchemaField>
      | ListIterateeCustom<FormSchemaField, boolean>
  ) => filter(formSchema?.[section] || [], condition);

  const hasSectionErrors = useCallback(
    (id: Sections) => {
      const flattenedErrors = omit(
        { ...errors, ...errors.custom_fields, ...errors.metadata },
        "custom_fields",
        "metadata"
      );

      return formSchema?.[id]?.some(({ name }) => !!flattenedErrors[name]);
    },
    [formSchema, JSON.stringify(errors)]
  );

  const isFirstInvalidSection = useCallback(
    (id: Sections) => find(keys(formSchema), hasSectionErrors) === id,
    [formSchema, JSON.stringify(errors)]
  );

  return {
    getFieldSection,
    isFieldVisible,
    getSectionFieldsBy,
    hasSectionErrors,
    isFirstInvalidSection
  };
};
